import {
	ACTIONS,
	PATH_HOME, RECEIVE_MODAL_ACTIONS, RECEIVE_MODAL_LOGIN_STATE,
	RECEIVE_USER_INFORMATIONS,
	RECEIVE_USER_ROLES,
	SET_BACKPATH,
	TITLE,
	TOASTR_ERROR,
	TOASTR_RESET,
	TOASTR_SUCCESS,
	WAIT
} from '../constants/HomeConstants'
import DtoUser from '../dto/DtoUser'
import DtoUserRole from '../dto/DtoUserRole'

export const store = {
	error: '',
	actions: [],
	success: '',
	backPath: PATH_HOME,
	wait: false,
	user: {
		address: '',
		administrator: false,
		administratorUser: '',
		city: '',
		email: '',
		firstName: '',
		fixNumber: '',
		lastName: '',
		latitude: '',
		login: '',
		longitude: '',
		mobileNumber: '',
		zoom: ''
	},
	title: '',
	userRoles: [],
	loginModalState: false,
	modalActions: []
}

export function HomeReducer(state = {}, action) {
	switch (action.type) {
		case TOASTR_ERROR: {
			return Object.assign({}, state, {
				error: action.message
			})
		}
		case TOASTR_SUCCESS: {
			return Object.assign({}, state, {
				success: action.message
			})
		}
		case TOASTR_RESET: {
			return Object.assign({}, state, {
				success: '',
				error: ''
			})
		}
		case WAIT: {
			return Object.assign({}, state, {
				wait: action.wait
			})
		}
		case RECEIVE_USER_INFORMATIONS: {
			return Object.assign({}, state, {
				user: new DtoUser(action.user)
			})
		}
		case RECEIVE_USER_ROLES: {
			return Object.assign({}, state, {
				userRoles: action.roles.map((el) => new DtoUserRole(el))
			})
		}
		case TITLE: {
			return Object.assign({}, state, {
				title: action.title
			})
		}
		case SET_BACKPATH: {
			const backPath = action.backPath ? action.backPath : PATH_HOME
			return Object.assign({}, state, {
				backPath: backPath
			})
		}
		case ACTIONS:
			return Object.assign({}, state, {
				actions: action.actions
			})
		case RECEIVE_MODAL_LOGIN_STATE:
			return Object.assign({}, state, {
				loginModalState: action.loginModalState
			})
		case RECEIVE_MODAL_ACTIONS:
			return Object.assign({}, state, {
				modalActions: action.modalActions
			})
		default:
			return state
	}
}




// WEBPACK FOOTER //
// ./src/home/reducers/HomeReducer.js